import { List, Create, Edit } from "../Components/index";

export default [
    {
        path: "/admin/leave-type",
        component: List,
        name: "leave-type-list",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/leave-type/:id/edit",
        component: Edit,
        name: "leave-type-edit",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/leave-type/create",
        component: Create,
        name: "leave-type-create",
        meta: {
            requiresAuth: true,
        },
    },
];
